import { Form } from "../../../core/entities/form";
import { formatDate } from "../../../core/functions/DateFormatUtility";
import { ReactComponent as SortNone } from "../../../resources/icons/sort_none.svg";
import { ReactComponent as SortAsc } from "../../../resources/icons/sort_asc.svg";
import { ReactComponent as SortDesc } from "../../../resources/icons/sort_desc.svg";
import { SortBy } from "../../../core/page-query/models/sortBy";
import { SortDirection } from "../../../core/page-query/models/sortDirection";
import { nameOf } from "../../../core/functions/nameof";

interface Props {
    list: Form[];
    sorting: SortBy;
    handleSortChanged: (sortBy: SortBy) => void;
    handleFormRow: (form: Form) => void;
}

export function FormsList({
    list,
    sorting,
    handleSortChanged,
    handleFormRow
}: Props) {
    const listItems = list.map((x) => {
        return (
            <tr
                key={x.id}
                className="text-left text-secondary-gray-dark text-xs font-medium border-b border-secondary-blue-light hover:bg-secondary-blue-subtle cursor-pointer"
                onClick={() => handleFormRow(x)}
            >
                <td className="p-16 truncate">{x.citizenSsn}</td>
                <td className="p-16">{x.citizenName}</td>
                <td className="p-16 truncate">{formatDate(x.createdAt)}</td>
                <td className="p-16">
                    {x.currentStatusDescription ?? <>&mdash;</>}
                </td>
                <td className="p-16">
                    {x.currentErrorCodeHeader ?? <>&mdash;</>}
                </td>
            </tr>
        );
    });

    function SortIcon({ column }: { column: string }) {
        if (column === sorting.field) {
            if (sorting.direction === SortDirection.ASC) {
                return (
                    <SortAsc
                        className="cursor-pointer"
                        onClick={() => {
                            handleSortChanged({
                                field: column,
                                direction: SortDirection.DESC
                            });
                        }}
                    />
                );
            }
            return (
                <SortDesc
                    className="cursor-pointer"
                    onClick={() => {
                        handleSortChanged({
                            field: column,
                            direction: SortDirection.ASC
                        });
                    }}
                />
            );
        }
        return (
            <SortNone
                className="cursor-pointer"
                onClick={() => {
                    handleSortChanged({
                        field: column,
                        direction: SortDirection.ASC
                    });
                }}
            />
        );
    }

    return (
        <table className="table-fixed flex-1 w-full">
            <thead>
                <tr className="text-left text-secondary-gray-dark text-xs font-normal border-b border-secondary-blue-light">
                    <th className="p-16 w-16">
                        <span className="flex gap-8">
                            Cpr
                            <SortIcon
                                column={nameOf<Form>((x) => x.citizenSsn)}
                            />
                        </span>
                    </th>
                    <th className="p-16 w-52">
                        <span className="flex gap-8">
                            Navn
                            <SortIcon
                                column={nameOf<Form>((x) => x.citizenName)}
                            />
                        </span>
                    </th>
                    <th className="p-16 w-16">
                        <span className="flex gap-8">
                            Oprettet
                            <SortIcon
                                column={nameOf<Form>((x) => x.createdAt)}
                            />
                        </span>
                    </th>
                    <th className="p-16 w-52">
                        <span className="flex gap-8">
                            Status
                            <SortIcon
                                column={nameOf<Form>(
                                    (x) => x.currentStatusCode
                                )}
                            />
                        </span>
                    </th>
                    <th className="p-16 w-52">
                        <span className="flex gap-8">
                            Fejl
                            <SortIcon
                                column={nameOf<Form>((x) => x.currentErrorCode)}
                            />
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>{listItems}</tbody>
        </table>
    );
}
